import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { Image } from "../../../components/Image";
import { Link } from "../../../components/Link";
import { LineStatus } from "../../../constants";
import { isoWebPageURL } from "../../../models/nominals";
import { format } from "../../../utils/format";
import { getDinero } from "../../../utils/money";
import { UnifiedOrderLookupLine } from "../types";

type IProps = Immutable<{
    styles: CSSModuleClasses;
    source: string;
    closestStep: string;
    lines: UnifiedOrderLookupLine[];
    warLink: string;
}>;

export const TrackShipmentDetailsLines = (props: IProps): React.JSX.Element => {
    if (props.lines.length == 0) {
        return <></>;
    }

    return (
        <>
            {props.lines.map((line, index) => {
                if (line.is_parent_line) {
                    return null;
                }
                const linePriceBeforeDiscountsExclTax =
                    line.line_price_before_discounts_excl_tax
                        ? getDinero(line.line_price_before_discounts_excl_tax)
                        : null;
                const postDiscountAddonTotalExclTax =
                    line.post_discount_addon_total_excl_tax
                        ? getDinero(line.post_discount_addon_total_excl_tax)
                        : null;
                const linePriceExclTax = line.line_price_excl_tax
                    ? getDinero(line.line_price_excl_tax)
                    : null;
                const lineMSRP =
                    linePriceBeforeDiscountsExclTax &&
                    postDiscountAddonTotalExclTax
                        ? linePriceBeforeDiscountsExclTax.subtract(
                              postDiscountAddonTotalExclTax,
                          )
                        : null;
                const lineActual =
                    linePriceExclTax && postDiscountAddonTotalExclTax
                        ? linePriceExclTax.subtract(
                              postDiscountAddonTotalExclTax,
                          )
                        : null;
                const specialEvent =
                    line.line_status === "Return Requested" ||
                    line.line_status === "Canceled" ||
                    line.line_status === null;
                return (
                    <section
                        key={`productLine-${index}`}
                        className={props.styles.shipmentItem}
                        role="group"
                        aria-label="product"
                    >
                        {specialEvent && (
                            <p className={props.styles.specialEvent}>
                                {line.line_status ?? "Canceled"}
                            </p>
                        )}
                        {line.product_image && (
                            <div className={props.styles.shipmentItemImage}>
                                {/* Forcing this to render client-side */}
                                {/* because for some bizarre reason, */}
                                {/* images totally break TrackOrderSummary */}
                                {/* but they work fine in TrackShipmentDetails */}
                                {getWindow() && (
                                    <Image
                                        lazy={false}
                                        src={line.product_image}
                                        alt=""
                                    />
                                )}
                            </div>
                        )}
                        <div className={props.styles.shipmentItemDetails}>
                            <div>
                                {/* <Link
                                    href={isoWebPageURL.wrap(
                                        lineQty.line.product_link || "",
                                    )}
                                >
                                    {lineQty.line.product_title}
                                </Link> */}
                                {line.product_title}
                            </div>
                            {line.product_attribute_summary && (
                                <div
                                    className={
                                        props.styles.shipmentItemAttributes
                                    }
                                >
                                    {line.product_attribute_summary}
                                </div>
                            )}
                            {lineMSRP && lineActual && (
                                <div>{t`Qty: ${line.quantity}`}</div>
                            )}
                        </div>
                        {!line.is_child_line ? (
                            <div className={props.styles.shipmentItemPrice}>
                                {lineMSRP && lineActual && (
                                    <>
                                        {lineMSRP.greaterThan(lineActual) ? (
                                            <>
                                                <span
                                                    className={
                                                        props.styles
                                                            .shipmentItemPriceRetail
                                                    }
                                                >
                                                    {format.money(lineMSRP)}
                                                </span>
                                                <span
                                                    className={
                                                        props.styles
                                                            .shipmentItemPriceActual
                                                    }
                                                >
                                                    {format.money(lineActual)}
                                                </span>
                                            </>
                                        ) : (
                                            <span>
                                                {format.money(lineActual)}
                                            </span>
                                        )}
                                    </>
                                )}
                                {!lineMSRP && !lineActual && (
                                    <span>{t`Qty: ${line.quantity}`}</span>
                                )}
                                {props.closestStep ===
                                    LineStatus.DELIVERED.valueOf() &&
                                    props.warLink.length > 0 &&
                                    props.source === "DTC" && (
                                        <Link
                                            href={isoWebPageURL.wrap(
                                                props.warLink,
                                            )}
                                        >
                                            {t`Leave a Review`}
                                        </Link>
                                    )}
                            </div>
                        ) : (
                            <p className={props.styles.bundleCallout}>
                                This item is part of a bundle
                            </p>
                        )}
                    </section>
                );
            })}
        </>
    );
};
